/******************************************************************************
 * RoleGuard: restrict a route to a set of realm roles.                       *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * RoleGuard: renders children only for users holding one of the allowed roles
*/

/* Imports */
import { useKeycloak } from "@react-keycloak/web";
import { Navigate } from "react-router-dom";
/***/

/**
* RoleGuard: renders its children only if the user holds at least one of the allowed realm roles,
* and redirects to the dashboard otherwise.
*
* Generalises SuperAdminGuard, which is the single-role case. Note this is a UX gate, not a security
* boundary — the API enforces the same rules server-side, and a user who forces the URL simply gets
* 403s from every call.
*
* @param roles - realm roles granting access, e.g. ["ROLE_ADMIN", "ROLE_PLANNER"]
* @param children - content rendered when the user holds one of them
*/
export default function RoleGuard({
  roles,
  children
}: {
  roles: string[];
  children: React.ReactNode;
}) {
  const { keycloak } = useKeycloak();
  const granted = keycloak.realmAccess?.roles ?? [];

  if (roles.some((role) => granted.includes(role))) return children;
  else return <Navigate to="/dashboard" replace />;
}
/***/
